import { postEditorErrorKeys, PostEditorErrorKeys, ValidatorFunctionObject } from '../../../../models/validator-props';
import { PostEditorErrors, PostGroupsType } from '../../../../models/post-editor';
import { cloneDeep } from 'lodash';
import { ErrorMessageSeverity } from '../../../../constants/form';
import { DeepReadonly } from '../../../../models/basic-objects';
import { InitialPostEditorState } from '../../states/initial';
import { ImmutabilityContext } from '../../states/effects/customImmutabilityContext';

// this function will return errors for the given postGroup and set error severity according to input param
export const validator = (
  postGroup: PostGroupsType,
  severity: ErrorMessageSeverity,
  errors: DeepReadonly<PostEditorErrors>,
  keys?: PostEditorErrorKeys[]
): PostEditorErrors => {
  if (postGroup.deleted) {
    // if the group has been deleted, make sure we reset the validation errors;
    return InitialPostEditorState().postGroups[0].errors;
  }
  if (keys) {
    const { update: updateImmutable } = ImmutabilityContext;
    let result = cloneDeep(errors);
    keys.forEach(key => {
      result = updateImmutable(result, {
        [key]: {
          $set: ValidatorFunctionObject[key](postGroup, severity)
        }
      });
    });
    // update severity for prev
    return result;
  } else {
    const result: PostEditorErrors = {} as PostEditorErrors;

    postEditorErrorKeys.forEach(key => {
      result[key] = ValidatorFunctionObject[key](postGroup, severity);
    });

    return result;
  }
};
